//noinspection JSFileReferences
import index from './homepage/index.js';

index.init();